export default __webpack_public_path__ + "static/hosting-shape6-8859bc5a317dc6a2e900b3606ea449a8.png";